import React, { useMemo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner, ListTransfer } from '~/components';
import { Input, Autocomplete, Select } from '~/components/Form';
import { storeData, updateData } from '~/store/modules/usuarios/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector((state) => state.usuarios);

  const [tank, setTank] = useState([]);

  const initials = create ? data : { ...find, ...data };

  const optionsTCA = useMemo(
    () => [
      { label: 'Sim', value: 'S' },
      { label: 'Não', value: 'N' },
    ],
    []
  );

  const optionsStatus = useMemo(
    () => [
      { label: 'Ativo', value: 'S' },
      { label: 'Inativo', value: 'N' },
    ],
    []
  );

  const cellsTransfer = useMemo(
    () => [{ id: 'post_desc', label: 'Posto' }],
    []
  );

  const itemsStart = useMemo(
    () => (create ? data.usuarioPosto || [] : find.usuarioPosto || []),
    [create]
  );

  const handleSubmit = useCallback(
    async (param) => {
      try {
        const schema = Yup.object().shape({
          usua_login: Yup.string()
            .typeError('Campo Obrigatório')
            .required('Campo Obrigatório'),
          usua_nome: Yup.string()
            .typeError('Campo Obrigatório')
            .required('Campo Obrigatório'),
          usua_email: Yup.string().email('Informe um e-mail válido.'),
          usua_senha: Yup.string()
            .typeError('Campo Obrigatório')
            .required('Campo Obrigatório'),
          perf_codigo: Yup.string()
            .typeError('Campo Obrigatório')
            .required('Campo Obrigatório'),
          usua_lib_abast: Yup.string()
            .typeError('Campo Obrigatório')
            .required('Campo Obrigatório'),
          usua_st_reg: Yup.string()
            .typeError('Campo Obrigatório')
            .required('Campo Obrigatório'),
        });

        await schema.validate(param, { abortEarly: false });

        const objSend = {
          usua_datahora_atu: null,
          usua_ultimo_acesso: null,
          usua_admin: 'N',
          ...initials,
          ...param,
          idcliente: client,
          usuarioPosto: tank,
        };

        if (create) dispatch(storeData(objSend, params));
        else dispatch(updateData(objSend, params));
      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          reference.current.setErrors(validationErrors);
        }
      }
    },
    [initials, client, tank]
  );

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input name="usua_login" label="Login" disabled={!create} />

          <Input name="usua_nome" label="Nome" />

          <Input name="usua_email" label="Email" />

          <Input name="usua_senha" label="Senha" type="password" />

          <Autocomplete
            name="perf_codigo"
            url="perfil"
            unique="perf_codigo"
            label="perf_descricao"
            title="Perfil"
          />

          <Select
            name="usua_lib_abast"
            label="Libera Abastecimento TCA"
            options={optionsTCA}
          />

          <Select name="usua_st_reg" label="Status" options={optionsStatus} />

          <ListTransfer
            grid
            url="usuarioposto/todos"
            unique="post_cod_posto"
            label="post_desc"
            leftTitle="Disponiveis"
            rightTitle="Selecionados"
            maxWidth="39"
            maxHeight="180"
            paginate={999}
            tree={false}
            showPaginate={false}
            cells={cellsTransfer}
            onCallback={(value) => setTank(value)}
            start={itemsStart}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
